/**
 * Shift-click range selection for the Freeze V2 embryo tables. Selects (or
 * clears) every id between the anchor and the clicked row in display order,
 * leaving selections outside the range untouched.
 */
export function applyRangeSelection({
  orderedIds,
  selectedIds,
  anchorId,
  targetId,
  checked,
}: {
  orderedIds: string[];
  selectedIds: string[];
  anchorId: string | null;
  targetId: string;
  checked: boolean;
}): string[] {
  const from = anchorId ? orderedIds.indexOf(anchorId) : -1;
  const to = orderedIds.indexOf(targetId);

  const range =
    from === -1 || to === -1
      ? [targetId]
      : orderedIds.slice(Math.min(from, to), Math.max(from, to) + 1);

  if (checked) return Array.from(new Set([...selectedIds, ...range]));
  const rangeSet = new Set(range);
  return selectedIds.filter((id) => !rangeSet.has(id));
}
